module.exports = __webpack_public_path__ + "img/quest_icon_0021_rang.6a4647d1.png";